import { memo } from 'react'
import PropTypes from 'prop-types'
import styled, { css } from 'styled-components'
import Image from '../../atomics/Image'
import Bold from '../../atomics/Typography/Bold'
import Text from '../../atomics/Typography/Text'
import Checkbox from '../../atomics/Checkbox/Checkbox'

const ContainerVariantItem = styled('div')`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  border: solid 2px ${props => (props.hasError ? 'red' : 'transparent')};
  border-top: solid
    ${props => (props.hasError ? '2px red' : '1px #b7b7b7')};
  border-radius: 10px;
  width: 100%;
  padding: 2%;
  padding-left: 58px;
  padding-right: 58px;
  &:hover {
    background-color: rgba(196, 196, 196, 0.3);
  }
  @media (max-width: 1100px) {
    flex-wrap: wrap;
    padding: 3%;
  }
`
const SubContainerImage = styled('div')`
  display: flex;
  flex: 1;
  align-items: center;
`
const VariantImage = styled(Image)`
  width: 94px;
  height: 94px;
  margin-left: 4%;
  margin-right: 4%;
  @media (max-width: 700px) {
    width: 76px;
    height: 76px;
  }
`
const SubContainerText = styled('div')`
  display: flex;
  flex-direction: column;
  width: 100%;
`
const VariantBold = styled(Bold)`
  font-weight: 500, Medium;
  font-size: 22px;
  line-height: 25.78px;
`
const VarianTextSku = styled(Text)`
  font-weight: 400;
  line-height: 32px;
  font-size: 20px;
  @media (max-width: 700px) {
    line-height: 22px;
    font-size: 14px;
  }
`
const VarianText = styled(VarianTextSku)`
  text-align: right;
`
const VarianTextRed = styled(VarianText)`
  color: rgba(124, 124, 124, 1);
  text-decoration: line-through;
  margin-left: 9px;
`

const SubContainerPrice = styled('div')`
  display: flex;
  flex-direction: column;
  justify-content: center;
`

const CheckboxStyled = styled(Checkbox)`
  align-self: center;
  ${props =>
    props.disabled
      ? css`
          visibility: hidden;
        `
      : null};
`
const VariantItemContainer = styled('div')`
  display: flex;
  flex-direction: row;
  display: flex;
  flex: 5;
  cursor: pointer;
`
const Row = styled('div')`
  display: flex;
  flex-direction: row;
  display: flex;
  width: 100%;
  @media (max-width: 1100px) {
    flex-wrap: wrap;
  }
`
const money = string =>
  String(string)?.replace(/\B(?=(\d{3})+(?!\d))/g, ',')

const VariantItem = memo(
  ({
    disabled,
    checked,
    onChange,
    variantId,
    variantAlt,
    variantImage,
    variantName,
    variantSku,
    variantQuantity,
    onClick,
    variantPrice,
    variantCompareAtPrice,
    hasError,
  }) => {
    return (
      <ContainerVariantItem hasError={hasError}>
        <CheckboxStyled
          aria-label="checkbox-variant"
          checked={checked}
          disabled={disabled}
          name={variantId}
          onChange={onChange}
        />
        <VariantItemContainer onClick={onClick}>
          <SubContainerImage>
            <VariantImage
              src={variantImage}
              alt={variantAlt || 'imagen'}
            />
            <SubContainerText>
              <VariantBold>{variantName}</VariantBold>
              {variantSku ? (
                <VarianTextSku>SKU Propio {variantSku}</VarianTextSku>
              ) : null}
            </SubContainerText>
          </SubContainerImage>
          <SubContainerPrice>
            <Row>
              <VarianText>CLP {money(variantPrice)}</VarianText>
              <VarianTextRed>
                CLP {money(variantCompareAtPrice)}
              </VarianTextRed>
            </Row>
            <VarianText>{variantQuantity} disponible (s)</VarianText>
          </SubContainerPrice>
        </VariantItemContainer>
      </ContainerVariantItem>
    )
  }
)

VariantItem.propTypes = {
  hasError: PropTypes.bool,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
  checked: PropTypes.bool,
  variantImage: PropTypes.string,
  variantName: PropTypes.string,
  variantSku: PropTypes.string,
  variantPrice: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  variantQuantity: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  variantId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  variantAlt: PropTypes.string,
  onClick: PropTypes.func,
  variantCompareAtPrice: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
}
VariantItem.defaultProps = {
  hasError: false,
  disabled: false,
  checked: false,
  variantImage: '',
  variantName: '',
  variantSku: '',
  variantPrice: 0,
  variantQuantity: 0,
  variantAlt: 'image-variant',
  variantCompareAtPrice: 0,
}
VariantItem.displayName = 'VariantItem'
export default VariantItem
